// Copy this object to environment.development.ts to debug old stage

export const environment = {
  production: false,
  debugProd: false,
  envName: 'dev',
  version: '3.0.2',
  url: 'linxio.com',
  appSubdomain: 'app',
  apiSubdomain: 'api-td_2',
  wsSubdomain: 'track2',
  chatSubdomain: 'messenger',
  goApiSubdomain: 'api.dev.v2',
  fileUrl: '',
  apiKey: 'AIzaSyDjdmUZd4iO4idixG_IiSeWbKENFc27bxc',
  mapBoxStyleEnv: 'stage',
  mapBoxAccessToken: 'pk.eyJ1IjoidmxhZGlzbGF2a2hvbWVua28iLCJhIjoiY2swMmVic3IzMHo4bDNvcXRjdnlqYm9kYyJ9.Ftod5X4gFFJ7IM05ShmJqw',
  fakeApis: false,
  apiMode: 'go' as 'go' | 'php',
  realtimeMode: 'v3' as 'v2' | 'v3',
}
